export default "__VITE_ASSET__DOnf7RR1__"